import Rails from '@rails/ujs'
import { setupIntent, preconditionGate, verifyIntent } from '../utils/stripe/setup-intent'

if(!window._rails_loaded) {
  Rails.start()
}
document.addEventListener('DOMContentLoaded', () => {
  const noScanLink = document.getElementById('no-scan')

  if(noScanLink) {
    noScanLink.addEventListener('click', () => {
      document.getElementById('otp-secret').classList.toggle('hidden')
    })
  }

  if (document.getElementById('payment-form')) {
    preconditionGate()
    setupIntent()
  }

  if (document.getElementById('payment-status')) {
    verifyIntent()
  }

  // Admin: Media URLs dynamic form
  const mediaUrlsContainer = document.getElementById('media-urls-container')
  const addMediaUrlButton = document.getElementById('add-media-url')

  if (mediaUrlsContainer && addMediaUrlButton) {
    addMediaUrlButton.addEventListener('click', function() {
      const row = document.createElement('div')
      row.className = 'media-url-row'
      row.style = 'display: flex; gap: 8px; align-items: center; margin-bottom: 8px;'
      row.innerHTML = `
        <input class="form-input" type="url" name="incoming_message[media_urls][]" placeholder="https://example.com/image.jpg" style="flex: 1;">
        <button class="btn remove-media-url" type="button">Remove</button>
      `
      mediaUrlsContainer.appendChild(row)
    })

    mediaUrlsContainer.addEventListener('click', function(e) {
      if (e.target.classList.contains('remove-media-url')) {
        e.target.closest('.media-url-row').remove()
      }
    })
  }

  const numberKindLocal = document.getElementById('number_kind_local')
  const einField = document.getElementById('ein-field')
  const radioContainer = document.getElementById('number_kind-radio-cards-container')

  if(radioContainer) {
    radioContainer.addEventListener('change', function (e) {
      if (e.target && e.target.matches('input[type="radio"]')) {
        if (numberKindLocal.checked) {
          einField.classList.remove('hidden')

        } else {
          einField.classList.add('hidden')
        }
      }
    })
  }
})


